import { VariableType } from '../Field';
import { ContinuousDomain, DiscreteDomain } from './Domain';
export class DomainCollect {
    constructor(query, result) {
        this._query = query;
        this._result = result;
        this._collect = this.buildCollect();
    }
    get query() {
        return this._query;
    }
    get result() {
        return this._result;
    }
    get collect() {
        return this._collect;
    }
    buildCollect() {
        const domains = new Map();
        this.query.fields.forEach((field) => {
            switch (field.varType) {
                case VariableType.DISCRETE:
                    domains.set(field.alias, new DiscreteDomain(field.dataType));
                    break;
                case VariableType.CONTINUOUS:
                    domains.set(field.alias, new ContinuousDomain(field.dataType));
                    break;
            }
            this.result.addDomain(field.alias, domains.get(field.alias));
        });
        let domain = null;
        return (row) => {
            for (const field of this.query.fields) {
                domain = domains.get(field.alias);
                if (domain && field.type === 'VIEWCALC' && field.formula.expr.type === 'SCALAR') {
                    domain.add(field.formula.expr.value({ row }));
                }
            }
        };
    }
}
